<template>
  <article class="infoContainer">
    <div class="container">
      <div class="titleContainer">
        <div class="bg"></div>
        <h1 class="title">{{ dataSheet.name }}</h1>
        <div class="date"><span>{{ dataSheet.start_time }} - {{ dataSheet.end_time }}</span></div>
      </div>
      <div class="infoContent articleBox">
        <h2 class="title">{{ $t("store.event.activity_methods") }}</h2>
        <section class="content">
          <p v-for="(item, index) in directions" :key="index">{{ item }}</p>
        </section>
      </div>
    </div>
  </article>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed:{
    directions(){
      const direction = this.dataSheet.summary;

      if(!direction){
        return [];
      }
      return direction.split('\n').filter((item) => item.trim() !== '');
    },
    ...mapState('signinSheet',['dataSheet'])
  }
}
</script>
